<p>
  <mat-form-field class="custom-domain--full-width" color="accent">
    <input
      matInput
      type="text"
      name="domain"
      [(ngModel)]="domainInput"
      (ngModelChange)="emitDomain()"
      placeholder="{{ 'PAGES.DOMAINS.CUSTOM_DOMAIN.ENTER_DOMAIN' | translate }}"
    />
  </mat-form-field>
</p>
<p>
  <mat-checkbox
    class="checkbox"
    name="buddyDomainSelected"
    [style.visibility]="buddyDomain ? 'visible' : 'hidden'"
    [(ngModel)]="buddyDomainSelected"
    (ngModelChange)="emitBuddyDomainFlag()"
  >
    {{ 'PAGES.DOMAINS.CUSTOM_DOMAIN.ALSO_ADD' | translate }}
    <i>{{ buddyDomain }}</i>
  </mat-checkbox>
</p>
